import React from 'react';
import { StepsContainer } from '../styles';
import { StepByStep } from '@gerdau/hefesto-mais-web';
import { Step } from '@gerdau/hefesto-mais-web/StepByStep/StepByStep.types';

interface Props {
  steps: Step[];
  activeStep: number;
  canShow: boolean;
}

export const DetailSteps = ({ steps, activeStep, canShow }: Props) => {
  if (!canShow) {
    return null;
  }

  return (
    <StepsContainer>
      <StepByStep steps={steps} activeStep={activeStep} />
    </StepsContainer>
  );
};
